import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Grow } from '@material-ui/core';

// eslint-disable-next-line react/display-name
const Transition = React.forwardRef((props, ref) => <Grow direction="up" ref={ref} {...props} />);

const AlertDialog = ({
  open,
  message,
  variant,
  children,
  yesAction,
  alertTitle,
  yesDisabled,
  cancelAction,
  yesButtonText,
  cancelButtonText
}) => (
  <Grid alignItems="center" container direction="column">
    <Dialog
      TransitionComponent={Transition}
      open={open}
      onClose={cancelAction}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">{alertTitle}</DialogTitle>
      <DialogContent>
        {children}
        {message}
      </DialogContent>
      <DialogActions>
        <Button variant={variant} onClick={cancelAction} color="default">
          {cancelButtonText}
        </Button>
        <Button disabled={yesDisabled} variant={variant} onClick={yesAction} color="secondary" autoFocus>
          {yesButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  </Grid>
);

export default AlertDialog;
